import * as THREE from 'three';
import type { TierDef } from './tiers';

const materialCache = new Map<number, THREE.MeshPhysicalMaterial>();

export function getMaterialForTier(tier: TierDef): THREE.MeshPhysicalMaterial {
  let mat = materialCache.get(tier.id);
  if (mat) return mat;

  mat = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(tier.color),
    roughness: tier.roughness,
    metalness: tier.metalness,
    emissive: new THREE.Color(tier.emissive),
    emissiveIntensity: tier.emissiveIntensity,
    clearcoat: tier.softness > 0.5 ? 0.55 : 0.25,
    clearcoatRoughness: 0.25 + (1 - tier.softness) * 0.3,
    sheen: tier.softness * 0.6,
    sheenRoughness: 0.4,
    sheenColor: new THREE.Color(tier.accent),
    reflectivity: 0.4,
    // Soft jelly look via slight transmission for wispy tiers
    transmission: tier.softness > 0.85 ? 0.22 : 0,
    thickness: tier.softness > 0.85 ? 0.6 : 0,
    ior: 1.4,
    flatShading: tier.shape === 'spark' || tier.shape === 'gem',
  });

  // Subtle color variation via onBeforeCompile could go here; keep simple for perf
  materialCache.set(tier.id, mat);
  return mat;
}

export function createAccentMaterial(color: number, emissive = 0, intensity = 0.2): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({
    color,
    emissive: new THREE.Color(emissive || color),
    emissiveIntensity: intensity,
    roughness: 0.4,
    metalness: 0.15,
  });
}

export function disposeMaterials(): void {
  for (const m of materialCache.values()) m.dispose();
  materialCache.clear();
}
